import { Form, Formik } from 'formik';
import { Modal } from 'app/shared/components/modals/Modal';
import { overrideValidationSchema } from '../../validations';
import { OverrideForm } from './OverrideForm';
import { IOverridePopupProps, OverrideFormFormikStateType } from './types';

export const OverrideModal = ({ handleClose, handleSubmit, isLoading }: IOverridePopupProps) => {
  const initialOverrideState: OverrideFormFormikStateType = {
    rate: null,
    term: null,
    lenderCode: '',
  };

  return (
    <Modal 
      open
      title="Override - Create New Deal"
      dialogWidth="25vw" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        validateOnChange
        initialValues={initialOverrideState as OverrideFormFormikStateType}
        validationSchema={overrideValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <OverrideForm handleClose={handleClose} isLoading={isLoading} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
